import * as Sentry from '@sentry/vue';
import { UserRole } from '../components/settings/User';

export default function ({ $axios, $auth0 }) {
  $axios.onRequest(async (config) => {
    // リクエスト前にアクセストークンを更新する
    try {
      Sentry.captureMessage(
        `アクセストークン更新 userid: ${$auth0.user.id} email: ${$auth0.user.mailaddress}`, 'info',
      );
      // tokenが生成されているかどうかの確認
      const token = await $auth0.updateTokenWithCache();
      if (token) {
        config.headers.common.Authorization = `Bearer ${token}`;
        return config;
      }
      throw new Error('アクセストークンが取得できませんでした');
    } catch (error) {
      Sentry.addBreadcrumb({
        category: 'auth',
        message: 'トークンリフレッシュ失敗',
        level: 'error',
        data: {
          message: error?.message,
          name: error?.name,
          stack: error?.stack,
        },
      });
      Sentry.captureException(error, {
        user: {
          id: $auth0.user.id,
          email: $auth0.user.mailaddress,
        },
      });
      // トークン取得失敗時はリロード
      if (process.env.DEVELOPMENT_TYPE !== 'static') {
        window.location.reload();
      }
      return config;
    }
  });

  // onError
  $axios.onError(({ response }) => {
    Sentry.addBreadcrumb({
      category: 'axios',
      message: `axiosリクエストエラー userid: ${$auth0.user.id} email: ${$auth0.user.mailaddress}`,
      level: 'error',
    });
    Sentry.captureException(response);
    if (response?.data) {
      if (response.data.statusCode === 401) {
        let redirectUri = window.location.origin;

        if (localStorage.getItem('role') !== UserRole.Patient) {
          redirectUri += `?role=${UserRole.Doctor}`;
        }

        $auth0.logout({
          returnTo: redirectUri,
        });
      }

      console.error(response.data);
    }
  });
}
